import { AdminAdDTOFields } from './Types/dto/admin/product'

export const missingFieldToRunEvent = (pr?: AdminAdDTOFields) => {
	if (!pr) {
		return ''
	} else if (!pr?.name) {
		return 'Esemény neve'
	} else if (Object.keys(pr?.adSubPages ?? {}).length == 0) {
		return 'Legalább egy árazási opció'
	} else if (
		pr?.timeSelectionType == 'oneOrManyTime' &&
		Object.keys(pr?.eventTimes ?? {}).length == 0
	) {
		return 'Legalább egy időpont'
	}

	for (const k in pr?.adSubPages) {
		let adSubPage = pr?.adSubPages[k]
		for (const k1 in adSubPage?.plans) {
			let plan = adSubPage?.plans[k1]
			for (const k2a in plan.paymentRecipients) {
				let paymentRecipient = plan?.paymentRecipients[k2a]
				for (const k2 in paymentRecipient.products) {
					let ii = paymentRecipient.products[k2]
					if (!ii.unitPrice) {
						return 'Ár az egyik számlatételen'
					} else if (ii.invoiceItemQuantityType == 'fix' && !ii.quantity) {
						return 'Mennyiség az egyik számlatételen'
					} else if (pr?.enableSendInvoice && !ii.unit) {
						return 'Mértékegység az egyik számlatételen'
					}
				}
			}
		}
	}

	// TODO: Put back, but for team
	/*for (const k in pr?.formFields) {
		let ffs = pr?.formFields[k]
		if (!ffs.name) {
			return 'Megnevezés az egyik űrlap mezőn'
		}
		for (const k2 in ffs.options) {
			let o = ffs.options[k2]
			if (!o.name) {
				return 'Megnevezés az egyik űrlapmezőhöz tartozó opción'
			}
		}
	}*/
}
